<script>
import { mapActions } from 'vuex';
import axios from 'axios';
import RbxFileList from '@/shared/reybex/RbxFileList';
import RbxFileUpload from '@/shared/reybex/RbxFileUpload';
import snackbarMixin from '@/mixins/snackbar';

export default {
  name: 'DocumentList',
  components: {
    RbxFileList,
    RbxFileUpload,
  },
  mixins: [snackbarMixin],
  data() {
    return {
      documents: [],
      isLoading: false,
      hasError: false,
      isAuthorized: false,
      id: null,
    };
  },
  created() {
    axios.post('/sharedDocument/authorize')
      .then((response) => {
        if (response.status === 200) {
          this.isAuthorized = true;
        }
      });
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    ...mapActions('attachment', ['fetchFileList']),
    onRemove() {
      this.fetchData();
    },
    onUploaded() {
      this.fetchData();
    },
    fetchData() {
      const { id } = this;

      this.isLoading = true;
      this.hasError = false;

      return this.fetchFileList({
        domain: 'sharedDocument/files',
        params: {
          id,
        },
      })
        .then(({ data }) => {
          this.documents = data;
        })
        .catch(() => {
          this.hasError = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<template>
  <div>
    <RbxFileUpload v-if="isAuthorized"
                   domain="SharedDocument"
                   @uploaded="onUploaded"
    />
    <RbxFileList
      :file-list="documents"
      :loading="isLoading"
      :readonly="!isAuthorized"
      @remove="onRemove"
    />
  </div>
</template>
